module.exports = __webpack_public_path__ + "static/media/signup-banner.7505fdd6.jpg";